import {Schema} from 'platform/components';

import {Dispatch, SetStateAction} from 'react';

import {Nullish} from 'shared/web';

import {
  ActivePreset,
  FeGridSettings,
  GetDataQueryResponse,
  Preset,
  VirtualPreset,
} from '../types/Api';
import {ConnectionOverride} from '../types/ConnectionOverride';
import {QueryFilterObject} from '../types/QueryFilterObject';

export type DataGridContext = {
  gridCode: string;
  connectionOverride?: ConnectionOverride;
  presetInstanceId?: string;
  externalFilterId?: string;
  filterSchema: Schema | Nullish;
  activePreset: ActivePreset;
  customPresets: Preset[];
  virtualPreset: VirtualPreset;
  setDataQuery: Dispatch<SetStateAction<GetDataQueryResponse | Nullish>>;
  settings: FeGridSettings;
  onExternalFilterChange?: (filterValues: Record<string, unknown>) => void;
  onActivePresetChange: Dispatch<SetStateAction<ActivePreset | Nullish>>;
  filterComponent?: any;
  queryModifier?: (filter: QueryFilterObject) => QueryFilterObject;
  disableAllActions?: boolean;
};
